var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unavailable-method"},[_c('p',{staticClass:"main"},[_vm._v("Método indisponível")]),_c('p',{staticClass:"text"},[_vm._v(" Para utilizar este método de pagamento, o valor mínimo da sua compra deve ser de "),_c('strong',[_vm._v(_vm._s(_vm._f("currency")(_vm.minValue)))]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }